import React from 'react';

import TrustLogo from '@rover/icons/svg/trust-logo.svg';
import { Box, Flex } from '@rover/kibble/core';
import Section from '@rover/kibble/patterns/Section';
import Elevator from '@rover/react-lib/src/components/utils/Elevator/Elevator';

import RoverProtectModal from '../RoverProtectModal';
import { MEMBER_PROFILE_SIGNAL_TEXT } from '../utils/RoverProtectSignals.constants';

const MemberProfileSignal = (): JSX.Element => {
  const elevatorStyles = {
    style: { borderRadius: '8px' },
  };

  return (
    <Section mb="12x">
      <Elevator elevation={1} {...elevatorStyles} data-testid="rover-guarantee-banner">
        <Flex
          alignItems="center"
          gap="8x"
          py="6x"
          px="4x"
          background="primary"
          sx={{ borderRadius: '8px' }}
        >
          <Box sx={{ minWidth: 'unset' }}>
            <TrustLogo width={36} height={48} />
          </Box>
          <Box>
            {MEMBER_PROFILE_SIGNAL_TEXT()} <RoverProtectModal />
          </Box>
        </Flex>
      </Elevator>
    </Section>
  );
};

export default MemberProfileSignal;
